module.exports = __webpack_public_path__ + "img/103067.974850d8.png";